const spkStationaer = {
  erstedaten: {
    typ_tt: `<h2>Wohnung oder Haus?</h2>
      <p>Geben Sie hier an, ob Sie den Hausrat in einer Wohnung oder einem Haus versichern möchten.</p>
      <p>Hier ist nur die Versicherung von dauerhaft bewohnten Objekten möglich.</p>`,
    tarifart: 'Arbeiten Sie in einer besonderen Berufsgruppe?',
    versicherbar: `<p>Hier ist nur die Versicherung von dauerhaft bewohnten Objekten möglich. Für die Versicherung von 
      Ferienwohnungen und -häusern oder WG-Zimmern wenden Sie sich bitte an die Versicherungsfachabteilung.</p>`,
  },
  produktvergleich: {
    Basis: {
      andereLeistungenTooltips: {
        wertsachen_hinweis: '',
        wertsachen_footer: '<p>Bitte sprechen Sie uns an, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
    },
    Komfort: {
      andereLeistungenTooltips: {
        wertsachen_hinweis: '',
        wertsachen_footer: '<p>Bitte sprechen Sie uns an, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
    },
    Premium: {
      andereLeistungenTooltips: {
        wertsachen_hinweis: '',
        wertsachen_footer: '<p>Bitte sprechen Sie uns an, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
    },
    tarif50Plus: {
      andereLeistungenTooltips: {
        wertsachen_hinweis: '',
        wertsachen_footer: '<p>Bitte sprechen Sie uns an, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
    },
    produkte: {
      vsu_berater: '',
    },
  },
  personendaten: {
    anschrift_tt: `<h2>Anschrift</h2>
    <p>Der Hausrat wird an der hier genannten Adresse versichert.</p>
    <ul class="list-icn-checkbullet">
      <li><strong>Sie möchten den Hausrat an einer anderen Adresse versichern?</strong> Dann nutzen Sie bitte den Link "Anschrift ändern".</li>
    </ul>
    $t(personendaten.anschrift_tt_subtext)`,
    anschrift_tt_subtext: '<p>Bitte beachten Sie, dass hier nur die Versicherung von dauerhaft bewohnten Objekten möglich ist. <strong>'
      + 'Für die Versicherung von Ferienwohnungen und -häusern</strong> wenden Sie sich bitte an'
      + ' die Versicherungsfachabteilung.</p>',
  },
  vorversicherung: {
    vsnr_label: 'Wie lautet die Versicherungsscheinnummer?',
    nichtversicherbar: '<p>Aufgrund der Vorschäden kann es zu Rückfragen durch den Fachbereich kommen.</p>',
  },
  zusammenfassung: {
    weiter: 'Drucken',
  },
};

export default spkStationaer;
